import React, { useEffect } from 'react';

interface IProps {
  onClose: () => void;
  label: string;
  /** 'lg' is the fixed-height order window; 'md' is narrower and sized to its content. */
  size?: 'lg' | 'md';
  children: React.ReactNode;
}

// Centred window over the dimmed list for order panels. A click on the backdrop closes it;
// Escape is handled by Auth.tsx. Body scrolling is locked while it is open.
const OrderPopup: React.FC<IProps> = ({
  onClose,
  label,
  size = 'lg',
  children,
}) => {
  useEffect(() => {
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, []);

  return (
    <div
      className="order-popup-scrim"
      role="presentation"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className={`order-popup${size === 'md' ? ' order-popup--md' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label={label}
      >
        {children}
      </div>
    </div>
  );
};

export default OrderPopup;
